<template>
    <transition name="fade">
        <div v-if="loading" :key="1" class="loading-overlay">
            <loader></loader>
        </div>
        <div class="quiz" v-else>
            <section class="content">
                <slot name="content" />
            </section>
            <section class="cta-container">
                <div class="quiz-buttons">
                    <slot name="cta-buttons" />
                </div>
                <div v-if="!hideExit" class="button transparent quiz-footer-buttons">
                    <button class="button transparent quiz-back-button" @click.stop="$router.go(-1)"></button>
                    <button class="button transparent quiz-exit-button" @click.stop="$router.push({ path: '/' })">Exit</button>
                    <slot name="exit-button-left" />
                </div>
            </section>
        </div>
    </transition>
</template>

<script>
    import Loader from '../common/loader.vue';

    export default {
        props: {
            loading: Boolean,
            hideExit: Boolean,
        },
        components: {
            Loader,
        },
        mounted() {
            this.$store.commit({
                type: 'footer/hideFooter'
            });
        },
    }
</script>

<style lang="scss">
    .quiz {
        .cta-container {
            .button {
                height: 46px;
                font-family: 'Lato';
                line-height: 46px;
                font-size: 14px;
                min-width: auto;
            }
            .quiz-buttons {
                > :nth-child(1) {
                    margin-right: 10px;
                }
                .button {
                    flex: 0.46;
                    padding: 0 20px;
                }
                .main-button {
                    flex: 0.8;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .quiz {
        background-color: #000;
        height: 100%;

        .cta-container {
            position: fixed;
            bottom: 0;
            width: 100%;
            z-index: 1000;
            background-color: black;
            .quiz-buttons {
                display: flex;
                justify-content: center;
            }
            .quiz-footer-buttons {
                width: 100%;
                max-width: 100%;
                border-top: 1px solid #F1F1F1;
                border-radius: 0;
                margin-top: 14px;
                @media screen and (min-height: 740px) {
                    margin-top: 28px;
                }
                
                .quiz-back-button {
                    position: absolute;
                    left: 0;
                    &:after {
                        content: '';
                        position: absolute;
                        top: calc(50% - 5px);
                        left: 18px;
                        width: 0;
                        height: 0;
                        border-top: 5px solid transparent;
                        border-bottom: 5px solid transparent;
                        border-right: 6px solid white;
                    }
                }
            }
        }
    }
    .loading-overlay {
        background-color: black;
    }
</style>